<template>
  <v-page page-class="account-page">
    <toolbar fixed>
      <template v-slot:left>
        <span class="v-toolbar__text">{{
          $t("pages.account.accountTitle")
        }}</span>
      </template>
    </toolbar>

    <template v-if="isAuthenticated">
      <subscriber-avatar-editor class="mx-auto mt-4 mb-2" :user="currentUser" />

      <div class="text-center mb-3">
        <h2 class="mb-0">{{ currentUser.name }}</h2>
        <p class="text-grey-70 text-small mt-1 d-block">
          {{ currentUser.email }}
        </p>
      </div>

      <div class="container mb-2 px-2">
        <add-to-homescreen context="account" />
      </div>

      <list boxed heading="Account">
        <list-item chevron @click="() => $router.push('/me/account/details')">
          <template slot="left">
            <v-icon icon="account_circle" />
          </template>
          <div class="v-list-item__title --centered ml-1">
            {{ $t("pages.account.accountDetails") }}
          </div>
        </list-item>
        <list-item chevron @click="() => $router.push('/me/account/purchases')">
          <template slot="left">
            <v-icon icon="attach_money" />
          </template>
          <div class="v-list-item__title --centered ml-1">
            {{ $t("pages.account.purchaseHistory") }}
          </div>
        </list-item>
        <list-item
          chevron
          @click="() => $router.push('/me/account/notifications')"
        >
          <template slot="left">
            <v-icon icon="notifications_none" />
          </template>
          <div class="v-list-item__title --centered ml-1">
            {{ $t("pages.account.notificationsHeading") }}
          </div>
        </list-item>
        <list-item
          chevron
          @click="() => $router.push('/me/account/subscriptions')"
        >
          <template slot="left">
            <v-icon icon="autorenew" />
          </template>
          <div class="v-list-item__title --centered ml-1">
            {{ $t("pages.account.subscriptionsHeading") }}
          </div>
        </list-item>
      </list>

      <list class="mt-2" boxed heading="Support">
        <list-item chevron @click="() => $router.push('/me/account/support')">
          <template slot="left">
            <v-icon icon="help_outline" />
          </template>
          <div class="v-list-item__title --centered ml-1">
            {{ $t("pages.account.getHelp") }}
          </div>
        </list-item>
        <list-item chevron @click="() => $router.push('/me/account/privacy')">
          <template slot="left">
            <v-icon icon="security" />
          </template>
          <div class="v-list-item__title --centered ml-1">
            {{ $t("pages.account.privacyAndTerms") }}
          </div>
        </list-item>
      </list>

      <div class="my-5">
        <v-button
          class="mt-2"
          data-cy="logout"
          ghost
          secondary
          block
          :is-loading="isLoggingOut"
          @click="logoutUser"
        >
          {{ $t("pages.account.logout") }}
        </v-button>
      </div>
    </template>

    <v-made-with-movement v-if="!isDesktop" />
  </v-page>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex"

import Toolbar from "@/components/Toolbar"
import List from "@/components/List"
import ListItem from "@/components/ListItem"
import AddToHomescreen from "@/components/AddToHomescreen"

export default {
  components: {
    Toolbar,
    AddToHomescreen,
    List,
    ListItem,
    SubscriberAvatarEditor: () => import("@/components/SubscriberAvatarEditor")
  },

  data() {
    return {
      isLoggingOut: false
    }
  },

  computed: {
    ...mapState("responsive", ["isDesktop"]),
    ...mapGetters("auth", ["currentUser", "isAuthenticated"]),
    ...mapGetters("pwa", ["canPrompt"])
  },

  methods: {
    ...mapActions("auth", ["logout"]),

    logoutUser() {
      this.isLoggingOut = true
      this.logout()
        .then(() => {
          this.$router.goHome()
        })
        .finally(() => {
          this.isLoggingOut = false
        })
    }
  }
}
</script>
